import Vue from 'vue'
import axios from 'axios'
// Element UI
import ElementUI from 'element-ui'
import langEn from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'element-ui/lib/theme-chalk/index.css'
// VueDataTables
import { DataTables } from 'vue-data-tables'

import VueI18n from 'vue-i18n'
import { loadLocaleMessages } from '@/locales/i18n'

import App from '../App'
import router from '../router'
import middlewarePipeline from '../middleware/middleware'
import store from '../store'

import VueHtmlToPaper from 'vue-html-to-paper'
import VueHtml2Canvas from 'vue-html2canvas'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import AuthService from '@/services/auth.service'
import SupplierService from '@/services/supplier.service'
import SupplyService from '@/services/supply.service'
import ItemService from '@/services/item.service'
import EmployeeService from '@/services/employee.service'
import DebtService from '@/services/debt.service'
import DepartmentService from '@/services/department.service'
import SalaryService from '@/services/salary.service'
import AccountService from '@/services/account.service'
import ReportService from '@/services/report.service'
import UserService from '@/services/user.service'
import ConfigService from '@/services/config.service'
import SessionService from '@/services/session.service'
import CategoryService from '@/services/category.service'
import CustomerService from '@/services/customer.service'
import DiscountService from '@/services/discount.service'
import ModifierService from '@/services/modifier.service'
import VariantService from '@/services/variant.service'
import TaxService from '@/services/tax.service'
import RoleService from '@/services/role.service'
import TransferService from '@/services/transfer.service'
import PermissionService from '@/services/permission.service'
import ServiceService from '@/services/service.service'
import WarehouseService from '@/services/warehouse.service'
import SaleService from '@/services/sale.service'
import ReceiptService from '@/services/receipt.service'
import PaymentMethodService from '@/services/payment.method.service'
import POSService from '@/services/pos.service'
import TicketService from '@/services/ticket.service'
import TicketNameService from '@/services/ticketName.service'
import SettingService from '@/services/setting.service'
import PrintService from '@/services/print.service'
import StoreService from '@/services/store.service'
import RoomService from '@/services/room.service'
import BookingService from '@/services/booking.service'
import ErrorService from '@/services/error.service'
import DashboardRobustService from '@/services/dashboard.robust.service'
import CountryService from '@/services/country.service'
import LabelPrintService from '@/services/labelPrint.service'
import LoyaltyService from '@/services/loyalty.service'
import ErrorNotification from '@/components/_Partials/ErrorNotification.vue'

import { formatPhone, longDateFormat, shortDateFormat, shortDateTimeFormat, slimDateFormat } from './helpers'
import CurrencyMixin from '@/mixins/CurrencyMixin'
import moment from 'moment'

// require('dotenv').config()
// Vue.prototype.$env = process.env
Vue.prototype.$moment = moment

locale.use(langEn) // Set ELEMENT UI default language
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// Helper function attachment
Vue.prototype.$longDate = longDateFormat
Vue.prototype.$shortDate = shortDateFormat
Vue.prototype.$shortDateTime = shortDateTimeFormat
Vue.prototype.$slimDate = slimDateFormat
Vue.prototype.$formatPhone = formatPhone

// Register global mixins
Vue.mixin(CurrencyMixin)

Vue.use(DataTables)

Vue.use(BootstrapVue)
Vue.use(VueI18n) // lang

// Load translations first
const i18n = new VueI18n({
  locale: store.getters['Auth/getLocale'] || process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

// Register global components
Vue.component('ErrorNotification', ErrorNotification)

// Created service instances
Vue.prototype.$errorService = new ErrorService(axios, store, router, i18n)
Vue.prototype.$authService = new AuthService(axios, store, router)
Vue.prototype.$supplierService = new SupplierService(axios, store, router)
Vue.prototype.$supplyService = new SupplyService(axios, store, router)
Vue.prototype.$itemService = new ItemService(axios, store, router)
Vue.prototype.$employeeService = new EmployeeService(axios, store, router)
Vue.prototype.$debtService = new DebtService(axios, store, router)
Vue.prototype.$departmentService = new DepartmentService(axios, store, router)
Vue.prototype.$salaryService = new SalaryService(axios, store, router)
Vue.prototype.$accountService = new AccountService(axios, store, router)
Vue.prototype.$reportService = new ReportService(axios, store, router)
Vue.prototype.$userService = new UserService(axios, store, router)
Vue.prototype.$configService = new ConfigService(axios, store, router)
Vue.prototype.$categoryService = new CategoryService(axios, store, router)
Vue.prototype.$customerService = new CustomerService(axios, store, router)
Vue.prototype.$discountService = new DiscountService(axios, store, router)
Vue.prototype.$modifierService = new ModifierService(axios, store, router)
Vue.prototype.$variantService = new VariantService(axios, store, router)
Vue.prototype.$taxService = new TaxService(axios, store, router)
Vue.prototype.$roleService = new RoleService(axios, store, router)
Vue.prototype.$transferService = new TransferService(axios, store, router)
Vue.prototype.$permissionService = new PermissionService(axios, store, router)
Vue.prototype.$sessionService = new SessionService(axios, store, router)
Vue.prototype.$serviceService = new ServiceService(axios, store, router)
Vue.prototype.$warehouseService = new WarehouseService(axios, store, router)
Vue.prototype.$saleService = new SaleService(axios, store, router)
Vue.prototype.$receiptService = new ReceiptService(axios, store, router)
Vue.prototype.$paymentMethodService = new PaymentMethodService(axios, store, router)
Vue.prototype.$posService = new POSService(axios, store, router)
Vue.prototype.$ticketService = new TicketService(axios, store, router)
Vue.prototype.$ticketNameService = new TicketNameService(axios, store, router)
Vue.prototype.$settingService = new SettingService(axios, store, router)
Vue.prototype.$storeService = new StoreService(axios, store, router)
Vue.prototype.$roomService = new RoomService(axios, store, router)
Vue.prototype.$bookingService = new BookingService(axios, store, router)
Vue.prototype.$countryService = new CountryService(axios, store, router)
Vue.prototype.$labelPrintService = new LabelPrintService(axios, store, router)
Vue.prototype.$loyaltyService = new LoyaltyService(axios, store, router)
Vue.prototype.$dashboardService = new DashboardRobustService(axios)

axios.defaults.baseURL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:4200/api/v1'
  : 'http://localhost/ss-api/public/api/v1'

axios.defaults.headers.common.Accept = 'application/json'
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  if (store.getters['Base/getBaseURL']) {
    config.baseURL = store.getters['Base/getBaseURL']
  }
  config.headers.Authorization = `Bearer ${store.getters['Auth/getToken']}`
  config.headers.Locale = `${store.getters['Auth/getLocale']}`

  /**
   * Skip setting the baseURL
   * - If axios is called anywhere else in the app with set baseURL
   * - Or if URL is already set
   */
  if (!config.baseURL || Object.keys(config.baseURL).length === 0) {
    config.baseURL = store.getters['Base/getBaseURL']
  }
  return config
}, function (error) {
  // Do something with request error
  // return Promise.reject(error)
  return error
})
// Add a response interceptor with enhanced error handling

axios.interceptors.response.use(function (response) {
  // Handle successful responses
  if (response.data.status !== 'success' && response.data.status !== 200) {
    // Show warning for non-success responses
    ElementUI.Notification({
      type: 'warning',
      title: i18n.t('status.warning'),
      message: response.data.message || 'Response indicates a warning',
      duration: 3000
    })
  }
  return response
}, function (error) {
  // Enhanced error handling using the new ErrorService
  console.error('Response error:', error)

  // Extract service name from URL for better context
  const url = error.config?.url || ''
  const method = error.config?.method || ''

  // Extract service name from URL (e.g., 'supplies/delete/123' -> 'supplies')
  const serviceName = url.split('/')[0] || 'unknown'

  // Extract action from URL path
  const urlParts = url.split('/')
  const action = urlParts.length > 1 ? urlParts[1] : 'request'

  // Use the new error service to handle all errors
  Vue.prototype.$errorService.handleError(error, {
    component: `${serviceName}-service`,
    action: action,
    url: url,
    method: method,
    service: serviceName
  })

  return Promise.reject(error)
})
Vue.http = Vue.prototype.$http = axios

Vue.config.productionTip = false
// Logger
// let log = require('electron-log')
// Load middleware
router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store,
    router
  }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})
const printEndpoint = axios.create({
  baseURL: 'http://localhost/salamanda-print/public/print',
  timeout: 5000,
  headers: {}
})
Vue.prototype.$printService = new PrintService(printEndpoint, store, router)

// i18n is already initialized above

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  // styles: [
  //   'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
  //   'https://unpkg.com/kidlat-css/css/kidlat.css'
  // ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ],
  timeout: 0,
  autoClose: false,
  windowTitle: window.document.title
}
Vue.use(VueHtml2Canvas)
Vue.use(VueHtmlToPaper, options)

export {
  Vue, axios, App, router, store, i18n
}
